import React from 'react';

import { observer } from 'mobx-react';

import { DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR } from 'core/constants';

import { AmendmentSummaryType } from 'utils/api/modules/entities/entities.types';
import { formatMoment } from 'utils/formatters/timezone';

import { VERSION_HISTORY_LABEL } from './constants';
import { NoticeContainer, NoticeText, NoticeFact, LinkButton } from './styles';

/**
 * A reader who saw this report before has no way of knowing a partner changed it since — version history closes that gap.
 */
const AmendmentNotice: React.FC<{
  summary: AmendmentSummaryType;
  onOpen: () => void;
}> = ({ summary, onOpen }): React.ReactElement => (
  <NoticeContainer data-testid="submission-amendment-notice">
    <NoticeText>
      <NoticeFact data-testid="submission-amendment-notice-fact">
        {`Version ${summary.currentVersion}, amended ${formatMoment(summary.lastAmendedAt, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}.`}
      </NoticeFact>
    </NoticeText>
    <LinkButton variant="text" onClick={onOpen} data-testid="submission-version-history-open">
      {VERSION_HISTORY_LABEL}
    </LinkButton>
  </NoticeContainer>
);

export default observer(AmendmentNotice);
